<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
        <BuyoutTabs></BuyoutTabs>
        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :title="`${$t('pages.buyout')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import API from '@/api/API'
  import Storage from '@/api/Storage'
  import { map, orderBy, values } from 'lodash'
  import Helper from '@/api/Helper'
  import TypeColor from '@/assets/TypeColor'
  import StatisticTable from '@/components/StatisticTable.vue'
  import BuyoutTabs from './BuyoutTabs.vue'
  import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    name: 'Buyout',
    components: {
      Filters,
      StatisticTable,
      BuyoutTabs
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          courierFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.courier'), field: 'courier'},
          {label: this.$root.$t('statistic.shipped'), field: 'shipped'},
          {label: this.$root.$t('statistic.delivered'), field: 'delivered'},
          {label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
          {label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2},
          {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2}
        ],
        rows: [],
        footColumns: {}
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.footColumns = {}
        let oldArrCurrency = []
        let newArrCurrency = []
        API.getBuyoutStatistic().then(response => {
          let statistic = {}
          map(response.data, d => {
            oldArrCurrency.push(d.local_currency.split(','))
            oldArrCurrency.forEach(array => {
              array.forEach(item => {
                newArrCurrency.push(item)
              })
            })
          })
          let filterCurrency = newArrCurrency.filter((item, index) => {
            return newArrCurrency.indexOf(item) === index
          })
          map(response.body, d => {
            if (!statistic[d.courier_id]) {
              statistic[d.courier_id] = d
            } else {
              statistic[d.courier_id].shipped += d.shipped
              statistic[d.courier_id].paid += d.paid
              statistic[d.courier_id].return += d.return
              statistic[d.courier_id].delivered += d.delivered
              statistic[d.courier_id].transit += d.transit
              statistic[d.courier_id].approved += d.approved
              statistic[d.courier_id].total_bill_usd += d.total_bill_usd
              statistic[d.courier_id].total_bill_local += d.total_bill_local
            }
          })
          let totalShipped = 0
          let totalReturn = 0
          let totalPaid = 0
          let countReturn = 0
          let totalTransit = 0
          let countTransit = 0
          let totalDelivered = 0
          let sumAverageBill = 0.0
          let sumTransit = 0
          let sumAverageBillLocal = 0.0
          map(statistic, (d) => {
            this.rows.push({
              courier: {
                value: `${Helper.getCourierTitle(Storage.couriers, d.courier_id)} ${Storage.developMode ? `(${d.courier_id})` : ''}`,
                style: {textAlign: 'left'}
              },
              shipped: {
                value: d.shipped,
                bg: true
              },
              delivered: {
                value: d.delivered,
                bg: true
              },
              transit: {
                value: d.transit,
                bgg: Helper.renderGistPart(d.shipped, d.transit),
                isCollspaned: true
              },
              transitPercents: {
                value: Helper.percents(d.shipped, d.transit),
                bgg: Helper.renderGistPart(d.shipped, d.transit, true)
              },
              return: {
                value: d.return,
                bgg: Helper.renderGistPart(d.shipped, d.return),
                isCollspaned: true
              },
              returnPercents: {
                value: Helper.percents(d.shipped, d.return),
                bgg: Helper.renderGistPart(d.shipped, d.return, true)
              },
              buyout: {
                colspan: 2,
                value: Helper.percents(d.shipped, d.delivered),
                dbgg: [
                    {name: 'delivered', width: parseFloat(Helper.percents(d.shipped, d.delivered - d.paid))},
                    {name: 'buyout', width: parseFloat(Helper.percents(d.shipped, d.paid))}
                ],
                htmlValue: `<p style="display: inline; float: left; margin-left: 5px; margin-bottom: 0;">${Helper.percents(d.shipped, d.delivered - d.paid)} ${Storage.developMode ? `(${d.delivered - d.paid})` : ''}</p> <p style="display: inline; float: right; margin-right: 5px; margin-bottom: 0;">${Helper.percents(d.shipped, d.delivered)} ${Storage.developMode ? `(${d.paid})` : ''}</p></div>`
              },
              averageBill: {
                value: d.approved > 0 ? '$ ' + (d.total_bill_usd / d.approved).toFixed(2) : '$ 0.0',
                  // bgg: Helper.renderSingleGist(100, Helper.averageBill(d.average_bill, false, true)),
                isCollspaned: true
              },
              averageBillLocal: {
                value: d.local_currency.split(',').length === 1 && d.approved > 0 ? `${(d.total_bill_local / d.approved).toFixed(0)} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, false), false)
              }
            })
            totalShipped += d.shipped
            totalDelivered += d.delivered
            if (d.return > 0) {
              totalReturn += d.return
              countReturn++
            }
            if (d.paid > 0) {
              totalPaid += d.paid
            }
            if (d.approved > 0) {
              sumAverageBill += parseFloat(d.total_bill_usd)
              sumTransit += parseInt(d.approved)
              sumAverageBillLocal += parseFloat(d.total_bill_local)
              this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
            }
            if (d.transit > 0) {
              totalTransit += d.transit
              countTransit++
            }
          })
          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            shipped: {
              value: totalShipped
            },
            delivered: {
              value: totalDelivered
            },
            transit: {
              value: `${totalTransit} (${Helper.average(totalTransit, countTransit)})`
            },
            transitPercents: {
              value: Helper.percents(totalShipped, totalTransit)
            },
            return: {
              value: `${totalReturn} (${Helper.average(totalReturn, countReturn)})`
            },
            returnPercents: {
              value: Helper.percents(totalShipped, totalReturn)
            },
            buyout: {
              value: `${Helper.percents(totalShipped, totalDelivered - totalPaid)} (${totalDelivered - totalPaid})`
            },
            buyoutPercents: {
              value: `${Helper.percents(totalShipped, totalDelivered)} (${totalDelivered})`
            },
            averageBill: {
              value: Helper.averageBillDayCount(sumAverageBill, sumTransit)
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBillLocal, sumTransit, this.localCurrencySymbol) : '-',
              graph: filterCurrency.length === 1 ? {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: this.localCurrencySymbol
              } : false
            }
          }
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Country.vue?77c7149c